var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.633 19.222l-7.225-7.224 7.225-7.225a1.703 1.703 0 10-2.408-2.408L12 9.59 4.775 2.365a1.703 1.703 0 10-2.408 2.408l7.225 7.225-7.225 7.224a1.703 1.703 0 002.408 2.409L12 14.406l7.225 7.225a1.703 1.703 0 102.408-2.409z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.049 2.047a2.153 2.153 0 013.045 0L12 8.953l6.906-6.906a2.153 2.153 0 113.045 3.044l-6.906 6.907 6.906 6.906a2.153 2.153 0 01-3.045 3.045L12 15.042 5.094 21.95a2.153 2.153 0 11-3.045-3.045l6.906-6.906L2.05 5.09a2.153 2.153 0 010-3.044zm1.522.27a1.253 1.253 0 00-.886 2.138l7.543 7.543-7.543 7.543a1.253 1.253 0 001.772 1.771L12 13.77l7.543 7.542a1.253 1.253 0 101.772-1.771l-7.543-7.543 7.543-7.543a1.253 1.253 0 10-1.772-1.772L12 10.226 4.457 2.683a1.253 1.253 0 00-.886-.367z",
    fill: "#C8C8C8"
  })));
}

export default SvgCrossIcon;